<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('distributorDeduction') }}</div>
      <div>
        <div>
          <b-button variant="default" to="distributor-deduction" class="btn-blue">{{ $tc('list') }}</b-button>
        </div>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('distributor', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{this.selectedDistributor}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema',1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{this.selectedCinema}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('movie',1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{this.selectedmovie}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('date') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ DistributorDeductions.dd_date | dateparse }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <table class="list-view-table">
              <thead>
                <tr>
                  <th>DEDUCTION LABEL</th>
                  <th>VALUE</th>
                  <th>PER SHOW/PER WEEK</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="col-md-12 py-2"
                  v-for="(distributordeduc, distributordeducIndex) in distributorDeductions"
                  :key="distributordeducIndex"
                >
                  <td>{{distributordeduc.dd_deduction_label}}</td>

                  <td
                    v-if="distributordeduc.dd_is_percentage == 'Y'"
                  >{{distributordeduc.dd_deduction_value.toFixed(this.MIN_FRACTION_DIGITS)}}%</td>
                  <td v-else>{{distributordeduc.dd_deduction_value.toFixed(this.MIN_FRACTION_DIGITS)}}</td>
                  <td v-if="distributordeduc.dd_per_show == 'Y'">PER SHOW</td>
                  <td v-else>PER WEEK</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div
                v-if="DistributorDeductions.createdby"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{DistributorDeductions.createdby}}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{DistributorDeductions.createdat | dateparse}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>

              <div
                v-if="DistributorDeductions.updatedby"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{DistributorDeductions.updatedby}}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
            </div>
          </div>

          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{DistributorDeductions.updatedat | dateparse}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import moment from "moment";
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";

export default {
  data() {
    return {
      selectedCinema: "",
      Movies: [],
      Cinemas: [],
      selectedmovie: "",
      distributors: [],
      selectedDistributor: "",
      selectedDistributorShareType: "Select Distributor Share Type",
      DistributorDeductions: {
        distributor_id: null,
        cinema_id: null,
        cinema_id_list: [],
        movie_details_id: null,

        dd_date: null,
        dd_is_active: "Y",
        created_by: null,
        created_at: null,
        updated_at: null,
        updated_by: null
      },
      distributorDeductions: {},
      DistributorMovies: []
    };
  },
  beforeMount() {
    const {
      cinema_id,
      movie_details_id,
      dd_date,
      distributor_id
    } = this.$route.query;
    let payload = {
      cinema_id: cinema_id,
      movie_details_id: movie_details_id,
      dd_date: dd_date,
      distributor_id: distributor_id
    };
    this.getSingleDistributionDeduction(payload);
  },
  methods: {
    getSingleDistributionDeduction: function(payload) {
      DistributorService.GetSingleDistributionDeduction(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.distributorDeductions = data.Records;
              this.DistributorDeductions = data.Records[0];
              this.getDistributorsList(payload.distributor_id);
              this.getCinemaList(payload.cinema_id);
              this.getMoviesList(
                payload.distributor_id,
                payload.cinema_id,
                payload.movie_details_id
              );
            }
          } else data && data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getCinemaList: function(cinema_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map(x => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getDistributorsList: function(distribution_ID) {
      let body = {
        tableName: "ms_distributors",
        d_is_active: "Y"
      };
      DistributorService.GetActiveDistributors(body)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map(x => {
              if (x.d_id == distribution_ID) {
                this.selectedDistributor = x.d_company_name;
              }
            });
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },

    getMoviesList: function(distributor_Id, cinema_Id, movie_ID) {
      if (distributor_Id && cinema_Id) {
        let payload = {
          distributor_id: distributor_Id,
          cinema_id: cinema_Id
        };
        DistributorService.GetDistributorDeductionsMovies(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              data.Records.map(x => {
                if (x.md_id == movie_ID) {
                  this.selectedmovie = x.movie_details;
                }
              });
            } else this.$toasted.show("Cannot find any movies");
          })
          .catch(this._CatchError);
      } else {
        this.$toasted.show("Please select distributors and cinemas");
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorDeduction/viewDistributorDeduction.vue